import React from 'react';
import './Process.css';

const log = [
  { hash: 'a1f03c2', type: 'chore', title: 'understand the problem', body: 'Who uses it, what breaks today, what “done” looks like.' },
  { hash: '7e9b410', type: 'feat', title: 'model the data & ship the API', body: 'Laravel or Node.js — schema first, endpoints second.' },
  { hash: 'c42d8e7', type: 'ui', title: 'build the interface', body: 'Angular, React or Vue on the web, Flutter in the pocket.' },
  { hash: '0b6fa95', type: 'ship', title: 'deploy, measure, iterate', body: 'Real users, real feedback, small fast releases.' },
];

const Process = () => (
  <section id="process" className="process wrap">
    <div className="process-intro">
      <h2 className="display display-lg">
        How a{' '}<br />project{' '}<br /><span className="process-accent">compiles.</span>
      </h2>
      <p className="process-lede">
        No hand-offs between a backend team and a frontend team — one person holds the whole
        thing in their head, so nothing gets lost between layers.
      </p>
    </div>

    <div className="terminal mono">
      <div className="terminal-bar">
        <span className="terminal-dot" />
        <span className="terminal-dot" />
        <span className="terminal-dot" />
        <span className="terminal-path">~/your-project — git log --oneline</span>
      </div>
      <ol className="terminal-body">
        {log.map((entry) => (
          <li key={entry.hash} className="commit">
            <span className="commit-hash">{entry.hash}</span>
            <span className="commit-msg">
              <span className="accent">{entry.type}:</span> {entry.title}
              <br />
              <span className="commit-body">{entry.body}</span>
            </span>
          </li>
        ))}
        <li className="commit-prompt">
          $ <span className="cursor" aria-hidden="true" />
        </li>
      </ol>
    </div>
  </section>
);

export default Process;
